<se-fe-page
  [seFeDataLoaded]="true"
  SeFeDataWidth="full"
  class="se-product-management error-page"
  id="se-product-management">
  <div seFePageHeader>
    <se-fe-header seFePageHeader seFeDataTitle="Commerce" size="750"></se-fe-header>
  </div>
  <se-fe-card seFePageContent>
    <se-fe-grid>
      <se-fe-card-content>
        <se-fe-grid seFeGridOpts="center">
          <se-fe-grid-cell>
            <se-fe-empty-state seFeDataTitle="An Error has Occurred.">
              <p>
                {{ message }}
                <br />
                Code: {{ code }}
              </p>
            </se-fe-empty-state>
          </se-fe-grid-cell>
        </se-fe-grid>
      </se-fe-card-content>
    </se-fe-grid>
  </se-fe-card>
</se-fe-page>
